
import axios from 'axios';

// app config
import AppConfig from 'Constants/AppConfig';
import AuthHeader from 'Constants/AuthHeader';

import { NotificationManager } from 'react-notifications';
import {
   MSKVISUAL_ACTION, 
   ALL_MSKVISUAL,
   FETCH_MSKYEAR,
   MSK_VISUALISATION_DETAILS,
   MSK_CREATE_VISUALISATION,
   MSK_VISUALISATION_DELETE,
   ALL_MSKSTUDENT
} from 'Actions/types';

/**
 * MSK Visualisation 
 */

export const allMSKStudents = () => async (dispatch) => {    
    
    
	  dispatch({ type: MSKVISUAL_ACTION});
		 return axios.get(AppConfig.apiurl+'/api/mskstudentlists', { headers: AuthHeader.header })
			.then( response => {   
				var resdata=response.data;		
                var resval=resdata.data;
				dispatch({ type: ALL_MSKSTUDENT, payload:resval}); 
				return Promise.resolve(resdata);
				
			})
			.catch( error => { 
				const errormsg=error.message
				NotificationManager.error(errormsg);
			}); 

}

export const allMSKVisualisation = (id) => async (dispatch) => {    
    
    var payload={
		"studentid":id
	}
	
	  dispatch({ type: MSKVISUAL_ACTION});
		 return axios.post(AppConfig.apiurl+'/api/fetchmskvisualisation', payload, { headers: AuthHeader.header })
			.then( response => {   
				var resdata=response.data;		
                var resval=resdata.data;
				dispatch({ type: ALL_MSKVISUAL, payload:resval}); 
				return Promise.resolve(resdata);
				
			})
			.catch( error => { 
				const errormsg=error.message
				NotificationManager.error(errormsg);
			}); 

}

export const studentMSKYears = (studentid) => async (dispatch) => {
	
	var payload={
		"studentid":studentid
	}
	
	  dispatch({ type: MSKVISUAL_ACTION});
		 return axios.post(AppConfig.apiurl+'/api/studentmskyears', payload, { headers: AuthHeader.header })
			.then( response => {   
				var resdata=response.data;		
                var resval=resdata.data;
				dispatch({ type: FETCH_MSKYEAR, payload:resval}); 
				return Promise.resolve(resdata);
				
			})
			.catch( error => { 
				const errormsg=error.message
				NotificationManager.error(errormsg);
			});

	
}

export const mskVisualisationDetails = (studentid, year, assessment, id) => async (dispatch) => {
	
	var payload={
		"oid":id,
		"studentid":studentid,
		"year": year,
		"assessment" : assessment
	}
	
	  dispatch({ type: MSKVISUAL_ACTION});
		 return axios.post(AppConfig.apiurl+'/api/mskvisualisationdetails', payload, { headers: AuthHeader.header })
			.then( response => {   
				var resdata=response.data;		
                var resval=resdata.data;
				dispatch({ type: MSK_VISUALISATION_DETAILS, payload:resval}); 
				return Promise.resolve(resdata);
				
			})
			.catch( error => { 
				const errormsg=error.message
				NotificationManager.error(errormsg);
			});

	
}


export const creatmskVisualisation = (mskstate, studentid, year, assessment, id) => async (dispatch) => {
	
	var payload={
		"oid":id,
		"studentid":studentid,
		"year": year,
		"assessment" : assessment,
		"shoulder_impression":mskstate.target.shoulder_impression.value,
		"latmuscle_impression":mskstate.target.latmuscle_impression.value,
		"spine_impression":mskstate.target.spine_impression.value,
		"hipright_impression":mskstate.target.hipright_impression.value,
		"hipleft_impression":mskstate.target.hipleft_impression.value,
		"hamright_impression":mskstate.target.hamright_impression.value,
		"gulteright_impression":mskstate.target.gulteright_impression.value,
		"balance_impression":mskstate.target.balance_impression.value,
		"posture_impression":mskstate.target.posture_impression.value
	}
	
	  dispatch({ type: MSKVISUAL_ACTION});
		 return axios.post(AppConfig.apiurl+'/api/createmskvisualisation', payload, { headers: AuthHeader.header })
			.then( response => {   
				var resdata=response.data;	
				dispatch({ type: MSK_CREATE_VISUALISATION}); 
				if(resdata.status==1){
					allMSKVisualisation('')(dispatch);
					NotificationManager.success(resdata.message);
				}else{
					NotificationManager.error(resdata.message);
				}
				
			})
			.catch( error => { 
				const errormsg=error.message
				NotificationManager.error(errormsg);
			});

	
}

export const deleteMskVisualisation = (id) => async (dispatch) => {
	
	var payload={
		"id":id
	}
	
	  dispatch({ type: MSKVISUAL_ACTION});
		 return axios.post(AppConfig.apiurl+'/api/deletemskvisualisation', payload, { headers: AuthHeader.header })
			.then( response => {   
				var resdata=response.data;	
				dispatch({ type: MSK_VISUALISATION_DELETE}); 
				if(resdata.status==1){
					allMSKVisualisation('')(dispatch);
					NotificationManager.success(resdata.message);
				}else{
					NotificationManager.error(resdata.message);
				}
				
			})
			.catch( error => { 
				const errormsg=error.message
				NotificationManager.error(errormsg);
			});

	
}






